// regex.js

export const regex = {
  firstName: /^[A-Za-z][A-Za-z '-]{1,50}$/,

  lastName: /^[A-Za-z][A-Za-z '-]{1,50}$/,

  password:
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,

  strongPassword:
    /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\W_])[A-Za-z\d\W_]{8,}$/,

  email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,

  contactNo: /^[6-9]\d{9}$/,

  macAddress: /^([0-9A-Fa-f]{2}([-:])){5}[0-9A-Fa-f]{2}$/,
};